import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915 } from "@faire/web-api--source/indigofair/settings/ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915";
export var getSettingEnableRetailerExclusivityAgreements = function() {
    return getSettingValueWithoutAssignment(ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915, false);
};
